/* global GLOBAL_PROMO_COOKIE_KEY */

import { cookie } from 'reduxModules/utils/cookie'

// SPEC-082: the promo cookie must be readable on every page, /checkout in
// particular. Written without a path, the browser scoped it to the directory
// of the page that set it, so a promo link landing on /subscriptions/plans
// stored it at path=/subscriptions: a full load of /checkout (reload, new
// tab, iOS crash-reload, PayPal return) could not see it and the subscribe
// went out without the coupon.
const PROMO_COOKIE_OPTIONS = { path: '/' }
// Where those pre-SPEC-082 copies live. Returning visitors may still carry
// one; on /subscriptions pages the browser lists it before the root cookie,
// so it would shadow every newer value.
const LEGACY_PROMO_COOKIE_OPTIONS = { path: '/subscriptions' }

const expireLegacyPromoCookie = (dispatch) =>
  dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY, null, LEGACY_PROMO_COOKIE_OPTIONS))

export const getGlobalPromoCookie = async (dispatch) => {
  const value = await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY))
  // Re-home whatever was read at path=/ (it may be a legacy
  // /subscriptions copy) so later full loads of other pages find it too
  if (value !== undefined) {
    await expireLegacyPromoCookie(dispatch)
    await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY, value, PROMO_COOKIE_OPTIONS))
  }
  return { value }
}

export const setGlobalPromoCookie = async (dispatch, value) => {
  await expireLegacyPromoCookie(dispatch)
  await dispatch(cookie(GLOBAL_PROMO_COOKIE_KEY, value, PROMO_COOKIE_OPTIONS))
}

// The server's per-plan promo entry carries discount_amount 0 wherever
// checkout would refuse the code — plan not discountable and not scoped at it
// (SPEC-062) — so this is the one place "does the promo apply here" is
// answered, with no plan id or name involved (SPEC-063).
export const promoDiscountForPlan = (globalPromo, plan) => {
  const entry = plan && globalPromo?.plans?.[plan.id]
  const amount = parseFloat(entry?.discountAmount)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}
